import React, { Component } from 'react';
import styles from './styles.scss';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WFirebase from '../../helpers/firebase';
import UserInfo from '../../helpers/userinfo';
import WModal from '../../components/WModal/WModal';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import { Button } from 'react-bootstrap';
import img_gas_desc from '../../static/views/gas/gas_desc.png';
class Gas extends Component 
{
  constructor(props){
    super(props);
    
    this.state={
      show_spinner:true,
      message:null,
      items:[]
    }

  }

  componentDidMount(){

    this.pullData()
  }

  pullData(){
    this.setState({ show_spinner: true });

    http.get(
      CONFIG.API_HOST + 'api/v1.3/gas', 
      { }, 
      (state, res) => {
        
        this.setState({ show_spinner: false });
        
        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (res.code !== 200) { return this.setState({ message: res.reason }); }

        const { gas_list }= res.data;

        const items = gas_list || [];

        this.setState({
          message: items.length === 0 && "目前沒有資料",
          items: items
        })
        console.log(this.state.items);
      }
    )
  }

  render()
  {

    return (
      <div className={styles.page_container}>

        
        
        { this.state.message &&  <WMask title={this.state.message} /> }
        
        {
          this.state.items && this.state.items.map((item, idx) =>
          {
            return (
              <div key={idx} >
                <div className={styles.list_title}>{item.name}</div>
                <div className={styles.item_container}>
                  {
                    item.items.map((item, index) =>
                      <GasItem content={item} key={index} callback={() => this.pullData()}/>
                    )
                  }
                </div>
              </div>

            )
          })
          
        }
        
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }

      </div>
    );
  }
}

export default Gas;

class GasItem extends Component
{
  constructor(props){
    super(props);

    console.log(props);
    
    this.state={
      deg: this.props.content.deg
    }

  }

  openModal(){

    this.refs.modal.show();

  }

  handleChange(event) {
    this.setState({deg: event.target.value});
  }

  onModalClick(title)
  {
    console.log('onModalClick', title)
    const {input_deg} = this.refs;
    
    if (title === '確認')
    {
      WFirebase.logEvent('GasMeterRecord',{'WriteMeter': UserInfo.houseid})
      http.post(
        CONFIG.API_HOST + 'api/v1.3/gas', 
        { id : this.props.content.id,
          deg: input_deg.value
        }, 
        (state, res) => {
          if (res.code !== 200)
          {

            return WModal.show(res.reason);
          }

          WModal.show(res.reason);

          if (this.props.callback) {this.props.callback()}
            
        }
      )
    }
  }

  render()
  {
    let record = this.props.content;
    return(
      <div>
      {/*<div  className={ record.can_report ? ([styles.list_item, styles.add_item].join(' '))  : styles.list_item}>*/}

        <div  className={ styles.list_item }>
          <div className={styles.info_block}>
            <div className={styles.title}> {record.month}月 </div>
            {
              record.can_report ? (
                  <div className={styles.content}>
                    <div className={styles.text}>
                      <span>住戶填寫：{record.deg}</span>
                    </div>
                    <div className={styles.text}>
                      <span>使用度數：{record.use_deg}</span>
                    </div>
                    <div className={styles.comment}>前次使用差異度數：{record.diff_deg}</div>
                  </div>
                // <div className={styles.content}>
                //   <div className={styles.action_container}>請輸入本月瓦斯度數
                //     <div className={styles.btn}>
                //       <img src={img_btn_plus} alt="填寫瓦斯度數" />
                //     </div>
                //   </div>
                //   <div className={styles.text}>
                //     <span>住戶填寫：{record.deg}</span>
                //   </div>
                //   <div className={styles.text}>
                //     <span>使用度數：{record.use_deg}</span>
                //   </div>
                //   <div className={styles.comment}>前次使用差異度數：{record.diff_deg}</div>
                // </div>
              ) : (
                <div className={styles.content}>
                  <div className={styles.text}>
                    <span>住戶填寫：{record.deg}</span>
                  </div>
                  <div className={styles.text}>
                    <span>使用度數：{record.use_deg}</span>
                  </div>
                  <div className={styles.comment}>前次使用差異度數：{record.diff_deg}</div>
                  <div className={styles.text}> 
                      { record.deg > 0 ? <span>{record.u_date}已填寫</span> 
                                       : <span>未填寫</span>
                      }
                  </div>
                </div>
              )
            }
          </div>
          {
            record.can_report &&
            <div className={styles.flex_box}>
              <Button bsStyle="primary" block className={styles.report_btn}
                onClick={ (e) => {
                    if (record.can_report)
                      this.openModal()
                  }
                }>填寫度數
              </Button>
              <div className={styles.text}>
                填寫期限：{record.exp_date}
                { record.deg > 0 ? <React.Fragment><br/><span>{record.u_date}已填寫</span></React.Fragment>
                                     : null
                }
              </div>
            </div>
          }
        </div>
        <WModal ref="modal" 
          title="請輸入瓦斯度數" 
          // message={}
          btns={['確認','取消']}
          subtitle={record.name}
          callback={(title) => this.onModalClick(title) }
          onClick={(title) => this.onModalClick(title) }>
            <React.Fragment>
              <img src={img_gas_desc} alt="填寫瓦斯度數" style={{width:'80%', margin:'auto'}}/>  
              <div className={[styles.form_group, styles.cal_input].join(' ')}>
                <input ref="input_deg" className={styles.form_control} defaultValue={this.state.deg} placeholder="0000.00"/>
              </div>
            </React.Fragment>
        </WModal>
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Gas/Gas.js